const __WEBPACK_NAMESPACE_OBJECT__ = require("@noble/curves/secp256k1");